import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AppHeader from '@/components/AppHeader';
import PoweredByFooter from '@/components/PoweredByFooter';
import { useTranslation } from '@/i18n/useTranslation';
import { contentMaxWidthForPath } from '@/lib/layout/content-width';
import styles from './AppLayout.module.css';

export default function AppLayout() {
  const { pathname } = useLocation();
  const t = useTranslation();
  const contentMaxWidth = contentMaxWidthForPath(pathname);

  useEffect(() => {
    document.title = t.appTitle;
  }, [t.appTitle]);

  return (
    <div
      className={styles.shell}
      style={{ '--content-max-width': contentMaxWidth } as React.CSSProperties}
    >
      {pathname !== '/' ? <AppHeader /> : null}
      <main className={styles.main}>
        <Outlet />
      </main>
      <PoweredByFooter />
    </div>
  );
}
